import { Product } from '~/commons/interfaces/models/content/product/Product'
import { getProductCustomField } from '~/helpers'

export function getProductSubTitle(
  product: Product
): string | null | undefined {
  return getProductCustomField(product, 'bs_sub_title')
}
